import { render, staticRenderFns } from "./NotificationsStudy.vue?vue&type=template&id=1b615a3e&"
import script from "./NotificationsStudy.vue?vue&type=script&lang=js&"
export * from "./NotificationsStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports